package com.essntl.core.quickbooks.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class QuickbooksCategoryRequest(
    @SerialName("Type")
    val type: String,
    @SerialName("Name")
    val name: String,
)